import { render, staticRenderFns } from "./interfaceAuthority.vue?vue&type=template&id=277472d4&"
import script from "./interfaceAuthority.vue?vue&type=script&lang=js&"
export * from "./interfaceAuthority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports